'use es6';

import { SELECTED_ITEM_UPDATED, SELECTED_ITEM_CLEARED, SELECTED_ITEM_REVERTED_TO_PREVIOUS, SELECTED_ITEM_UPDATED_STYLE_SECTION_TOUR_STEP, CLEAR_USE_SCROLL_IF_MODULE_OUT_OF_BOUNDS_AT_ALL, FREEZE_NODE_POSITIONS, THAW_NODE_POSITIONS } from 'ContentEditorUI/redux/actions/actionTypes';
import { getSelectedItemId, getIsPostBodyOrChildModuleSelected } from '../selectors/selectionSelectors';
import { getIsLayoutSectionModuleIsIn } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { getIsModuleStyleable } from 'ContentEditorUI/redux/selectors/styleSelectors';
import { getPreviewIframeNeedsRefresh } from 'ContentEditorUI/redux/selectors/inpageSelectors';
import { toggleApplyChangesModalOpen } from 'ContentEditorUI/redux/actions/appActions';
import { getIsDistractionFreeOpen } from 'ContentEditorUI/redux/selectors/localCachedSettingsSelectors';
import { toggleDistractionFree } from 'ContentEditorUI/redux/actions/distractionFreeActions';
export const updateSelectedItem = (id, {
  activeTab,
  containerId,
  shouldScrollToModule,
  doNotShowSidebarForm,
  clearOutPanels,
  stayOnCurrentPanel
} = {}) => (dispatch, getState) => {
  // If the module isn't styleable, switch the activeTab to the default tab.
  // We're adding this logic here, because the getIsModuleStyleable isn't memoized
  // and it causes performance issues when called multiple times. This will be removed when
  // https://git.hubteam.com/HubSpot/ContentEditorUI/issues/9191 gets addressed.
  const reduxState = getState();
  if (activeTab === 'style') {
    const isModuleNotStyleable = !getIsModuleStyleable(reduxState, id);
    if (isModuleNotStyleable) {
      activeTab = null;
    }
  }
  const previewIframeNeedsRefresh = getPreviewIframeNeedsRefresh(reduxState);
  const isDistractionFreeOpen = getIsDistractionFreeOpen(reduxState);
  const isPostBodyOrChildModuleSelected = getIsPostBodyOrChildModuleSelected(reduxState, id);

  // Automatically fill the container id for modules in a D&D area
  containerId = containerId || getIsLayoutSectionModuleIsIn(reduxState, id);
  const opts = {
    id,
    activeTab,
    containerId,
    shouldScrollToModule,
    doNotShowSidebarForm,
    clearOutPanels,
    stayOnCurrentPanel
  };
  if (previewIframeNeedsRefresh) {
    const applyChangesModalOpts = {
      selectionInProgress: opts,
      routingInProgress: null
    };
    dispatch(toggleApplyChangesModalOpen(true, applyChangesModalOpts));
  } else {
    if (isDistractionFreeOpen && !isPostBodyOrChildModuleSelected) {
      // This action is dispatched again in the BlogRichText widget with
      // `shouldScrollToModule = true` when the distraction free close
      // animation is complete.
      opts.shouldScrollToModule = false;
      dispatch(toggleDistractionFree(false));
    }
    dispatch({
      type: FREEZE_NODE_POSITIONS,
      iframeOnly: true
    });
    setTimeout(() => {
      dispatch({
        type: THAW_NODE_POSITIONS,
        iframeOnly: true
      });
    }, 250);
    dispatch({
      payload: opts,
      type: SELECTED_ITEM_UPDATED
    });
  }
};
export const updateSelectedItemStyleSectionDropdown = (id, containerId) => {
  return {
    payload: {
      id,
      containerId
    },
    type: SELECTED_ITEM_UPDATED_STYLE_SECTION_TOUR_STEP
  };
};
export const clearSelectedItem = (opts = {
  onlyIfSelected: null
}) => (dispatch, getState) => {
  const reduxState = getState();
  const onlyIfSelected = opts.onlyIfSelected;

  // Only clear selection if the id that triggered the action  is the one that's currently selected
  // (or onlyIfSelected was unspecified)
  const previewIframeNeedsRefresh = getPreviewIframeNeedsRefresh(reduxState);
  const selectedItemId = getSelectedItemId(reduxState);
  const isPostBodyOrChildModuleSelected = getIsPostBodyOrChildModuleSelected(reduxState, selectedItemId);
  if (previewIframeNeedsRefresh) {
    dispatch(toggleApplyChangesModalOpen(true));
    // Need == not === so we can check for null and undefined
  } else if (onlyIfSelected == null || selectedItemId === onlyIfSelected) {
    if (getIsDistractionFreeOpen(reduxState) && !isPostBodyOrChildModuleSelected) {
      dispatch(toggleDistractionFree(false));
    }

    // In patagonia blurring a module from preview iframe closes the sidebar.
    // However, going out of module from content panel or optimize panel back to previous panel should not close the sidebar
    const shouldClosePatagoniaSidebar = opts.returnToPreviousPanel === false;
    dispatch({
      type: SELECTED_ITEM_CLEARED,
      payload: {
        onlyIfSelected,
        closePatagoniaSidebar: shouldClosePatagoniaSidebar
      }
    });
  }
};
export const revertToPreviousSelection = () => ({
  type: SELECTED_ITEM_REVERTED_TO_PREVIOUS
});
export const clearUseScrollIfModuleOutOfBoundsAtAll = () => {
  return {
    type: CLEAR_USE_SCROLL_IF_MODULE_OUT_OF_BOUNDS_AT_ALL
  };
};